import React, { useState } from "react";
import { Box, Button, Chip, CircularProgress, Grid, IconButton, Link, Stack, Typography, useTheme } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";
import { Field, Form } from "react-final-form";
import { cache } from '../../utils/cache';
import { TextFieldCustom } from "../../components/FormElements";
import { CloseLineIcon, FilterIcon, iconFontSize, SearchIcon } from "../../components/IconComponent";
import CardComponent from "../../components/Card";
import DrawerComponent from "../../components/Drawer";
import { formatDateToDDMMYYYYHHSSFrEpoch } from "../../utils/util";
import { GetIconColor } from "../../theme/main_style";

export default function ServiceRequestView(props) {
    const { t } = useTranslation();
    const { palette } = useTheme();
    const { serviceRequests, serviceRequestNotes, openSearch, showLoadingServiceRequestsByValue} = props;

    const renderRoot = () => {
        return (
            <>
            <DrawerComponent isOpen={props.open} onClose={props.onClose} title={t('service_requests')} showProcessing={props.showProcessing} message={props.message} headerPosition='relative' width='100%'
                right= {<>
                <IconButton onClick={() => props.onClickSearch()}>
                    <SearchIcon color={palette.primary.main}/>
                </IconButton>
                <IconButton onClick={() => props.onOpenFilter()}>
                    <FilterIcon color=""/>
                </IconButton>
                </>}
            >
                {renderContent()}
            </DrawerComponent>
            </>
        )
    }

    const renderContent = () => {
        return (
            <>
                <Grid>
                    {props.filterSelected && props.filterSelected.states && props.filterSelected.queue_id[0].id !== 'ALL' &&
                    <Stack direction={'row'} mt={2} mr={1}>
                            <Stack direction={'row'} spacing={1} alignItems='center'>
                                <Typography variant="subtitle2" color={palette.text.primary}>{t('classification')}: </Typography>
                                {props.filterSelected.queue_id.map((item, index) => {
                                    return (
                                        <Button 
                                            endIcon={<CloseLineIcon size={iconFontSize.xs} color={GetIconColor().primary} />}
                                            variant="outlined"
                                            sx={{
                                                padding: "5px 15px",
                                                backgroundColor: palette.background.main,
                                                '&:hover': {
                                                    backgroundColor: palette.background.main,
                                                    color: palette.primary.main,
                                                },
                                            }}
                                            onClick={() => props.onSelectFilter("queue_id", item)}>{item.name}
                                        </Button>
                                    )})
                                }
                            </Stack>
                        
                    </Stack>}

                    {props.filterSelected && props.filterSelected.states && props.filterSelected.states[0].id !== 'ALL' &&
                    <Stack direction={'row'} mt={1} mr={1}>
                            <Stack direction={'row'} spacing={1} alignItems='center'>
                                <Typography variant="subtitle2" color={palette.text.primary}>{t('state')}: </Typography>
                                {props.filterSelected.states.map((item, index) => {
                                    return (
                                        <Button 
                                            endIcon={<CloseLineIcon size={iconFontSize.xs} color={GetIconColor().primary} />}
                                            variant="outlined"
                                            sx={{
                                                padding: "5px 15px",
                                                backgroundColor: palette.background.main,
                                                '&:hover': {
                                                    backgroundColor: palette.background.main,
                                                    color: palette.primary.main,
                                                },
                                            }}
                                            onClick={() => props.onSelectFilter("states", item)}>{item.name}
                                        </Button>
                                    )})
                                }
                            </Stack>
                    </Stack>}

                    
                </Grid>
                <Grid>
                    <Stack direction={'row'} justifyContent='flex-end' mt={2} mr={1}>
                        <Link onClick={() => props.setShowAddSR(true)} id='serviceRequest/New'>+ {t('new_service_request')}</Link>
                    </Stack>
                </Grid>
                <Box px={2} py={2}>
                    {openSearch && 
                        <Grid item xs={12}>
                            <Form
                                onSubmit={props.searchServiceRequests}
                                render={({ handleSubmit }) => (
                                    <Grid item xs={12}>
                                        <Grid item xs={12} marginY={2}>
                                            <Field
                                                name="search_service_requests"
                                                component={TextFieldCustom}
                                                xs={{color: palette.text.primary}}
                                                classes={{backgroundColor: palette.background.main,borderRadius: 16}}
                                                placeholder={t('search_service_requests_placeholder')}
                                                isEdit={true}
                                                onCustomChange={async (value) =>{
                                                    props.searchServiceRequests(value)}
                                                }
                                                disabled={showLoadingServiceRequestsByValue}
                                                endAdornment={<Box classes={{backgroundColor: palette.background.card}}>{<Stack sx={{cursor: 'pointer',}}><SearchIcon color={palette.primary.main} /></Stack>}</Box>}
                                            />
                                        </Grid>
                                    </Grid>
                                )} />
                        </Grid>
                    }
                     
                    <InfiniteScroll
                        hasMore={serviceRequests.paging.has_more}
                        dataLength={serviceRequests.content.length}
                        next={props.handleLoadMoreserviceRequests}
                        // height={window.innerHeight-150}
                        backgroundColor={palette.mode === 'dark' ? '#383434' : palette.background.paper}
                        loader={props.showLoadMoreServiceRequests ? <center><CircularProgress size={'1.25rem'} /></center> : null}
                    >
                        {serviceRequests && serviceRequests.content && serviceRequests.content.length>0 ? 
                            <Grid item xs={12} maxHeight={'75vh'} overflow='auto'>
                                {serviceRequests.content.map((item, index) => {
                                    return (
                                        <div key={index} style={{cursor: 'pointer'}}>
                                            <ServiceRequestsItem item={item}
                                                showLoadingDetail={props.showLoadingDetail}
                                                serviceRequest={props.serviceRequest}
                                                onOpenFile={props.onOpenFile}
                                                index={index}
                                                serviceRequestNotes={serviceRequestNotes}
                                                onShowDetail={props.onShowDetail}
                                            />
                                        </div>
                                    )
                                })}
                            </Grid>
                            :
                            <Typography variant="subtitle2">{t('no_service_requests_found')}</Typography>
                        }
                    </InfiniteScroll>

                   
                </Box>
            </>
        )
    }
    return (
        <>
            {renderRoot()}
        </>
    )
}

function ServiceRequestsItem(props) {
    const { item } = props;
    const { palette } = useTheme();
    const [showBreakdown, setsShowBreakdown] = useState(false);

    let config = cache.getAppConfig();
    let isDarkMode = config && config.appearance && config.appearance.dark_mode;

    return (
        <CardComponent  noBorder={true} bg={isDarkMode ? '#383434' : palette.background.paper}>
           <Box py={1.5} marginTop={1} px={1} bgcolor={isDarkMode ? '#383434' : palette.background.paper} borderRadius={'15px'} border={`1px solid ${palette.border.main}`}>
                <Stack direction={'row'} spacing={1} alignItems='center' onClick={() => {
                    props.onShowDetail(item)
                    setsShowBreakdown(!showBreakdown)
                }}>

                    <Stack flex={1}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography variant="h6">{item.number}</Typography>
                                <Chip sx={{ borderRadius: 2 }} size="small" label={item.classification}/>
                            </Stack>
                            <Chip sx={{ borderRadius: 2 }} size="small" label={item.stage?.name} style={{ backgroundColor: item.stage?.colour }} />
                        </Stack>

                        <Typography variant="subtitle2"  style={{opacity:  0.7 }}>{item.created_date ? formatDateToDDMMYYYYHHSSFrEpoch(item.created_date) : undefined}</Typography>
                        {item.description &&
                            <Typography mt={2} variant="subtitle2">{item.description.length>100 ? item.description.slice(0,100) + '...' : item.description}</Typography>
                        }
                    </Stack>
                </Stack>
            </Box>
        </CardComponent>
    )
}